/** 列表缩略图 imageType 优先级：1 建筑物 > 2 入口 > 3 出口（不含 4 公示牌） */
const THUMB_TYPE_PRIORITY = ['1', '2', '3']

function sortByDisplayOrder(a, b) {
  const ao = Number(a.displayOrder ?? 0)
  const bo = Number(b.displayOrder ?? 0)
  return ao - bo
}

/**
 * @param {Array} images
 * @returns {string|null}
 */
export function pickParkingListThumbUrl(images) {
  if (!images || !images.length) {
    return null
  }
  for (const type of THUMB_TYPE_PRIORITY) {
    const hit = images
      .filter((img) => String(img.imageType) === type)
      .sort(sortByDisplayOrder)[0]
    if (hit) {
      return hit.thumbUrl || hit.imageUrl || null
    }
  }
  return null
}

/**
 * @param {object} parking
 * @returns {string|null}
 */
export function resolveParkingListThumb(parking) {
  if (!parking) {
    return null
  }
  if (parking.thumbImageUrl) {
    return parking.thumbImageUrl
  }
  return pickParkingListThumbUrl(parking.parkingImagesList)
}
